var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrumNova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4390_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32601 4H6.12797C5.97617 4 5.84069 4.09492 5.78861 4.23748L0.0110854 20.076C-0.0318746 20.1939 0.0553654 20.3186 0.180765 20.3186H2.37881C2.53061 20.3186 2.66609 20.2236 2.71817 20.0812L8.49569 4.24252C8.53865 4.12468 8.45141 4 8.32601 4ZM10.9995 10.6365C10.9418 10.4782 10.718 10.4782 10.6601 10.6365L9.52061 13.7608C9.49145 13.8407 9.49145 13.9284 9.52061 14.0084L11.7358 20.0811C11.7878 20.2236 11.9234 20.3184 12.0752 20.3184H14.2732C14.3986 20.3184 14.4858 20.1938 14.4429 20.0759L10.9995 10.6365ZM16.6029 13.6946C16.6606 13.8528 16.8844 13.8528 16.9421 13.6946L20.39 4.24252C20.4329 4.12468 20.3457 4 20.2203 4H18.0222C17.8704 4 17.735 4.0948 17.6829 4.23748L15.4632 10.3226C15.4341 10.4025 15.4341 10.4901 15.4632 10.57L16.6029 13.6946ZM12.269 4.2358C12.2175 4.0942 12.0828 4 11.9322 4H9.72677C9.57509 4 9.43961 4.0948 9.38753 4.23736L3.61013 20.076C3.56717 20.1939 3.65441 20.3186 3.77981 20.3186H5.97797C6.12977 20.3186 6.26525 20.2238 6.31733 20.0812L10.7408 7.95424C10.7698 7.87468 10.8822 7.87468 10.9112 7.95424L15.3347 20.0812C15.3867 20.2238 15.5223 20.3186 15.6741 20.3186H17.8722C17.9976 20.3186 18.0849 20.1939 18.0419 20.0762L12.269 4.2358ZM23.8193 4H21.621C21.4694 4 21.3338 4.0948 21.2818 4.23736L17.2626 15.2558C17.2335 15.3357 17.2335 15.4233 17.2626 15.5032L18.4024 18.6278C18.4601 18.786 18.6839 18.786 18.7416 18.6278L22.7202 7.7206L23.989 4.2424C24.032 4.12468 23.9447 4 23.8193 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4390_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrumNova);
export default __webpack_public_path__ + "static/media/arbitrum-nova.5c2e8bac4afd3a939896beeeac401e6d.svg";
export { ForwardRef as ReactComponent };